// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"styles_loadingOverlay__l0WCe","logoSpinner":"styles_logoSpinner__cp7hc","spin":"styles_spin__7-QyK"};